<script>
export default {
  props: {
    module: Object,
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    toggleButton: false,
    icon: 'el-icon-arrow-up',
    display: 'block',
  }),
  methods: {
    toggle() {
      if (this.toggleButton) {
        this.icon = 'el-icon-arrow-down';
        this.display = 'none';
      } else {
        this.icon = 'el-icon-arrow-up';
        this.display = 'block';
      }
      this.toggleButton = !this.toggleButton;
    },
    add(index, elem) {
      this.module.add(elem);
    },
    remove(index, elem) {
      this.module.remove(elem);
    },
    change(elem) {
      this.module.change(elem);
    },
  },
};
</script>
<template>
  <Card class="card-main card-additional-service">
    <CardTitle>
      Дополнительные услуги
    </CardTitle>
      <CardBody v-if="module.services.length">
        <el-table
          :data="module.services"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Название услуги">
          </el-table-column>
          <el-table-column
            prop="price"
            width="150"
            label="3а Человека">
          </el-table-column>
          <el-table-column
            prop="fullPrice"
            width="140"
            label="Итого">
          </el-table-column>
          <el-table-column
            width="150"
            label="">
            <template slot-scope="scope">
              <div style="display: flex" v-if="!scope.row.isGroup">
                <el-button
                  size="mini"
                  type="primary"
                  @click="remove(scope.$index, scope.row)" circle> - </el-button>
                <div class="p-t-c-i__additional-service-count">{{scope.row.count}}</div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="add(scope.$index, scope.row)" circle> + </el-button>
              </div>
              <div style="display: flex;position:relative;margin-left: 41px;" v-if="scope.row.isGroup">
                <input type="checkbox" class="p-t-c-i__additional-service-checkbox"  :id="`checkbox-${scope.row.id}`" :name="`checkbox-${scope.row.id}`" v-model="scope.row.checked" @change="change(scope.row)">
                <label :for="`checkbox-${scope.row.id}`"></label>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </CardBody>
    </Card>
</template>
<style lang="scss" scoped>
.card-additional-service {
    table {
      th {
        color:  #07080F;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.8px;
        text-transform: uppercase;
      }

      tr {
        color: var(--6-b-7582, #6B7582);
        font-family: Roboto;
        font-size: 14px;
        line-height: normal;
      }

      button {
        width: 34px;
        height: 34px;
        background:rgba(27, 94, 32, 0.6);
        color: black;
        font-size: 20px;
        border-color: rgba(27, 94, 32, 0.6);
      }
    }

  .p-t-c-i__additional-service-count {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 40px;
        padding-top: 3px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        gap: 10px;
    }

  .p-t-c-i__additional-service-checkbox {
      position: absolute;
      z-index: -1;
      opacity: 0;

      & + label {
        display: inline-flex;
        align-items: center;
        user-select: none;

        &:before {
          content: '';
          display: inline-block;
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          flex-grow: 0;
          border-radius: 6px;
          border: 1px solid #adb5bd;
          margin-right: 0.5em;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 50% 50%;
        }
      }

      &:checked {
        + label {
          &:before {
            border-color: black;
            background-color: rgba(27, 94, 32, 0.6);
            background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='BLACK' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/></svg>");
          }
        }
      }
    }
}
</style>
